export default "__VITE_ASSET__BG2CgOep__"